import * as Yup from "yup";

export const validatorOTP = Yup.string()
  .length(6, "Must be exactly 6 digits")
  .matches(/^[0-9]+$/, "Must be exactly 6 digits")
  .required("A six digit code is required.");
